// The Writing Studio student journey — an ORIENTATION/PROGRESS layer over the existing architecture.
// Student-facing stage names only (never OT / FSC / Essay Controller / controller state). This module is
// pure config + helpers; it reads nothing and drives no engines. Five student-facing stages (the underlying
// developmental architecture is NOT linear and is unchanged).
// Unified pre-composition workspace (Increment C): "Develop & Organize My Thinking" is ONE stage — the old
// "Organizing Your Thoughts" + separate "Developing Your Writing" (FSC) are merged. The underlying
// developmental architecture is recursive/non-linear and unchanged.
export const FULL_JOURNEY = [
  { key: "develop_thinking", title: "Develop & Organize My Thinking", blurb: "Work out what you think, how your ideas connect, and how they answer the assignment — ready to begin writing." },
  { key: "organize_essay", title: "Organizing Your Essay", blurb: "Shape your writing around a clear thesis and make the parts work together." },
  { key: "sentence_craft", title: "Sentence Craft", blurb: "Strengthen your sentences so they communicate clearly." },
  { key: "proofreading_final", title: "Proofreading & Final Review", blurb: "Find and fix surface-level errors, then review your finished work and your development." },
];

// Composition Only begins farther along the same path — it must NOT show earlier stages as skipped/failed.
export const COMPOSITION_JOURNEY_KEYS = ["organize_essay", "sentence_craft", "proofreading_final"];

// Map any older internal/student key onto the current stages (resume compatibility). The former
// organize_thoughts + developing_writing/elaborate both fold into the unified develop_thinking stage.
const LEGACY_KEY_MAP = {
  understand_assignment: "develop_thinking",
  organize_thoughts: "develop_thinking",
  develop_thinking: "develop_thinking",
  elaborate: "develop_thinking",
  developing_writing: "develop_thinking",
  organize_essay: "organize_essay",
  sentence_craft: "sentence_craft",
  proofreading: "proofreading_final",
  final_review: "proofreading_final",
  proofreading_final: "proofreading_final",
};

export function mapJourneyKey(key) {
  return LEGACY_KEY_MAP[key] || key;
}

export function journeyFor(pathway) {
  return pathway === "composition"
    ? FULL_JOURNEY.filter((s) => COMPOSITION_JOURNEY_KEYS.includes(s.key))
    : FULL_JOURNEY;
}

// status of each stage relative to the current one: "completed" | "current" | "upcoming"
export function stageStatuses(stages, currentKey) {
  const cur = mapJourneyKey(currentKey);
  const idx = stages.findIndex((s) => s.key === cur);
  return stages.map((s, i) => ({
    ...s,
    number: i + 1,
    status: idx < 0 ? "upcoming" : i < idx ? "completed" : i === idx ? "current" : "upcoming",
  }));
}
